// extracted by mini-css-extract-plugin
module.exports = {"container":"_1zgH-r6rm5eftqpiDfcfi","groupsList":"_1pTwSFQMG9fjb7AS2iepbi"};